import { TableCell, useTheme } from "@mui/material";
import { ReactElement } from "react";

interface PropType {
  key: string;
  tittle: string;
  children: ReactElement;
}
const TableBodyCell = (props: PropType) => {
  const {  key, children } = props;
  const theme = useTheme();

  return (
    <TableCell
      sx={{
        whiteSpace: "pre-wrap",
        fontSize: theme.font?.fontSize.tableBody,
        padding: "1rem 0rem",
        minWidth:'13rem',
        boxSizing: "border-box",
        textAlign: "center",
        justifyContent: "center",
      }}
      key={key}
    >
      {children} 
    </TableCell>
  );
};
export default TableBodyCell;
